import React from 'react';
import useInvalidateRouteGroup from '@Hooks/Routes/useInvalidateRouteGroup';
import useRouteGroup from '@Hooks/Routes/useRouteGroup';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import AppSetting from './AppSetting';

const SettingsRoute = () => {
	const routeGroup = useRouteGroup('settings');

	const { path, url } = useRouteMatch();
	useInvalidateRouteGroup({
		mode: 'end',
		baseURL: '/dashboard/settings',
		routeGroup: routeGroup,
		routePlacement: 2,
	});

	return (
		<>
			<Switch>
				{routeGroup && !Array.isArray(routeGroup) && (
					<>
						<Route exact path={url}>
							<AppSetting />
						</Route>

						{routeGroup.routes.map((_) => {
							return (
								<Route strict path={`${path}/${_.route}`} key={_.route}>
									{_.component}
								</Route>
							);
						})}
					</>
				)}
			</Switch>
		</>
	);
};

export default SettingsRoute;
